import { Box, Button, Divider, Tab, Tabs } from "@mui/material"
import UndoIcon from '@mui/icons-material/Undo';
import { useState } from "react";

import VerifiedIcon from '@mui/icons-material/Verified';
import CollectionsIcon from '@mui/icons-material/Collections';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import PrimaryTable from "../../components/Table/PrimaryTable";
import ApprovedCase from "./ApprovedCase";
import CollectionCase from "./CollectionCase";
import LoanCase from "./LoanCase";



const TabPanel = ({ children, value, index }) => {
    return value === index ? (
        children
    ) : null;
};

const AppCollLoan = ({leadData,setLeadData}) =>{
    const [value, setValue] = useState(0);

       

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

      

    return (
        <Box>


<Box sx={{display: "flex",justifyContent: "space-between",alignItems: 'center'}}>

    <Tabs value={value} onChange={handleChange} aria-label="icon label tabs example">
      <Tab icon={<VerifiedIcon />} label="Approval Case" />
      <Tab icon={<CollectionsIcon />} label="Collection Case" />
      <Tab icon={<CreditScoreIcon />} label="Loan Case" />
    </Tabs>

                <Button onClick={() => {setLeadData(null)} } variant="contained"  color='secondary' className='text-white' >
                            <UndoIcon /> Go Back
                </Button>
</Box>



      <TabPanel value={value} index={0}>
                                            <ApprovedCase leadData={leadData}/>
      </TabPanel>
      <TabPanel value={value} index={1}>
                 <CollectionCase leadData={leadData}/>
      </TabPanel>
      <TabPanel value={value} index={2}>
                 <LoanCase leadData={leadData}/>
                   
      </TabPanel>

    

                                
        </Box>
    ) 
}


export default AppCollLoan
